import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {BehaviorSubject, Observable} from "rxjs";
import {TRANSLATOR_LANGUAGES, TranslatorLanguage} from '../../models/translator';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  selectedLanguageSubject$: BehaviorSubject<any> = new BehaviorSubject<any>("");
  private readonly isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) private readonly platformId: object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.selectedLanguageSubject$.next(this.getBrowserLanguage());
  }

  getBrowserLanguage(): string {
    if (!this.isBrowser) {
      return TranslatorLanguage.EN;
    }

    const browserLang = navigator.language.split('-')[0].toLowerCase();
    return TRANSLATOR_LANGUAGES.includes(browserLang as TranslatorLanguage)
      ? browserLang
      : TranslatorLanguage.EN;
  }

  setLanguage(language: any) {
    this.selectedLanguageSubject$.next(language);
  }

  getCurrentLanguage(): Observable<any> {
    return this.selectedLanguageSubject$.asObservable();
  }

}
